// extracted by mini-css-extract-plugin
module.exports = {"main":"y88Kz_","about":"g037Mf","menu":"QAMCHS","list":"s2Ulr1","item":"ZwS7so","active":"jinM78","link":"APj5sW","break":"T6zvm4"};